import { LoadingButton } from "@mui/lab";
import {
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { TYPE_NOTIFICATION } from "../../../../components/reusable/NotificationBull";
import StandardSkeletoon from "../../../../components/reusable/loader/StandardSkeletoon";
import useConfirm from "../../../../hooks/useConfirm";
import { useQuery } from "../../../../hooks/useQuery";
import useToast from "../../../../hooks/useToast";
import { SousDomaineService } from "../../../../services/candidature/SousDomaineService";

const INIT_SOUS_DOMAINE_INFO = {
  id_sous_domaine: "0",
  name: "",
  description: "",
  id__domaine: "0",
  active: "TRUE",
};

const INIT_FORM_ERROR = {
  name_error: null,
  description_error: null,
  id__domaine_error: null,
  active_error: null,
};

const SousDomaineDialogForm = ({
  open,
  onFormClose,
  onFormOpen,
  id_domaine,
  idSousDomaine,
  idForm,
}) => {
  const [sousDomaineInfo, setSousDomaineInfo] = useState(
    INIT_SOUS_DOMAINE_INFO,
  );
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const { Toast, showToast } = useToast();
  const url = useQuery();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleFormClose = () => {
    if(onFormClose) onFormClose();
    setSousDomaineInfo(INIT_SOUS_DOMAINE_INFO);
  };

  const handleChangeFormInfo = (e) => {
    const { name, value } = e.target;
    setSousDomaineInfo({ ...sousDomaineInfo, [name]: value });
  };

  const handleFetchSousDomaineInfo = () => {
    setFormLoading(true);
    SousDomaineService.find_one({ id_sous_domaine: idSousDomaine })
      .then((res) => {
        if (res && res.data) {
          setSousDomaineInfo(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      name_error: sousDomaineInfo.name ? null : "Nom est obligatoire",
      description_error: sousDomaineInfo.description
        ? null
        : "Description est obligatoire",
      id__domaine_error: null,
      active_error: null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleSave = () => {
    if (idSousDomaine) {
      handleUpdate();
    } else {
      handleInsert();
    }
  };
  const handleInsert = () => {
    setSubmited(true);
    setLoading(true);
    SousDomaineService.insert({...sousDomaineInfo, id__domaine: id_domaine })
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleUpdate = () => {
    setSubmited(true);
    setLoading(true);
    SousDomaineService.update({...sousDomaineInfo, id__domaine: id_domaine })
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      handleSave();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    if (sousDomaineInfo) {
      handleCheckDataValidation();
    }
  }, [sousDomaineInfo]);

  useEffect(() => {
    setSousDomaineInfo({ ...sousDomaineInfo, id__domaine: url.get("dom") });
    if (idForm || open) {
      handleFetchSousDomaineInfo();
    }
  }, [idForm, open]);

  return (
    <>
      <DialogComponent />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Toast />
        <Grid>
          <StandardSkeletoon escalier={true} m={4} row={4} show={formLoading} />
        </Grid>
        <Paper
          sx={{ m: 3, display: formLoading ? "none" : "block" }}
          elevation={0}
        >
          <Grid>
            <CardHeader
              title={
                idSousDomaine ? "Modifier sous domaine" : "Creer sous domaine"
              }
            />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Sous domaine</label>
                  <TextField
                    multiline
                    rows={2}
                    id="name"
                    name="name"
                    onChange={handleChangeFormInfo}
                    size="small"
                    value={sousDomaineInfo.name || ""}
                    error={formErrors.name_error && submited}
                    helperText={submited ? formErrors.name_error : ""}
                    placeholder="Inserer ici le sous domaine"
                    fullWidth
                    aria-describedby="question_helper"
                  />
                </FormControl>
                <FormControl fullWidth>
                  <label>Description</label>
                  <TextField
                    multiline
                    rows={2}
                    id="description"
                    name="description"
                    onChange={handleChangeFormInfo}
                    size="small"
                    value={sousDomaineInfo.description || ""}
                    error={formErrors.description_error && submited}
                    helperText={submited ? formErrors.description_error : ""}
                    placeholder="Inserer ici la description"
                    fullWidth
                    aria-describedby="question_helper"
                  />
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <LoadingButton
                loading={loading}
                title={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              >
                Enregistrer
              </LoadingButton>
              <Button
                title={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              >
                Fermer
              </Button>
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default SousDomaineDialogForm;
